"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TheThext = _native.default.Text(_templateObject(), function (props) {
  return props.muistyles;
}, function (props) {
  return props.styles;
});

var Text =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Text, _Component);

  function Text() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getTextTheme", (0, _memoizeOne.default)(function (props, context) {
      // $FlowFixMe
      var _getTheme = (0, _ThemeProvider.getTheme)('Text', props, context),
          trace = _getTheme.trace,
          theme = (0, _objectWithoutPropertiesLoose2.default)(_getTheme, ["trace"]);

      var bold = props.bold,
          italic = props.italic,
          size = props.size,
          uppercase = props.uppercase,
          color = props.color;
      return (0, _ThemeProvider.getPropertiesFromTheme)((0, _objectSpread2.default)({}, theme, {
        color: color || theme.color,
        fontWeight: bold ? 'bold' : theme.fontWeight,
        fontStyle: italic ? 'italic' : theme.fontStyle,
        fontSize: size || theme.fontSize,
        textTransform: uppercase ? 'uppercase' : theme.textTransform
      }));
    }));
    return _this;
  }

  var _proto = Text.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        bold = _this$props.bold,
        italic = _this$props.italic,
        uppercase = _this$props.uppercase,
        size = _this$props.size,
        color = _this$props.color,
        other = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "bold", "italic", "uppercase", "size", "color"]);
    var muistyles = this.getTextTheme(this.props, this.context);
    return _react.default.createElement(TheThext, (0, _extends2.default)({
      muistyles: muistyles
    }, other), children);
  };

  return Text;
}(_react.Component);

exports.default = Text;
(0, _defineProperty2.default)(Text, "contextType", _ThemeProvider.default);